const formatarData = (data) => {

    //console.log(data);
    if (!data) return "";
  
    // Verifica se a data está no formato YYYY-MM-DD
    if (/^\d{4}-\d{2}-\d{2}$/.test(data)) {
      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}/${ano}`;
    }
  
    const novaData = new Date(data);
  
    // Verifica se a data é válida
    if (isNaN(novaData)) {
      return "Data inválida";
    }
  
    const dia = String(novaData.getDate()).padStart(2, "0");
    const mes = String(novaData.getMonth() + 1).padStart(2, "0");
    const ano = novaData.getFullYear();
  
    //console.log(`${dia}/${mes}/${ano}`);
    return `${dia}/${mes}/${ano}`;
  };
  
  export default formatarData;

